const NewMessagesDevider = () => {
  return (
    <div className="devider same-sender fadeOut">
      <div className="devider-content">
        <div className="text">
          <hr aria-hidden="true" />
        </div>
      </div>
      <div className="devider-side">
        <div aria-label="New messages devider ">new messages</div>
      </div>
    </div>
  );
};

export default NewMessagesDevider;
